import { render, staticRenderFns } from "./ReviewStats.vue?vue&type=template&id=c08ba302&scoped=true&"
import script from "./ReviewStats.vue?vue&type=script&lang=js&"
export * from "./ReviewStats.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStats.vue?vue&type=style&index=0&id=c08ba302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ba302",
  null
  
)

export default component.exports